import React, { useEffect, useState } from 'react'
import Image from 'next/image'

interface Props {
  images: string[]
  imageAlt?: string
  selectedVariant?: { imageUrls?: string[] } | null
}

const ProductImageCarousal: React.FC<Props> = ({ images, imageAlt, selectedVariant }) => {
  const variantImages = selectedVariant?.imageUrls ?? []
  const effectiveImages = variantImages?.length > 0 ? variantImages : images
  const [mainImage, setMainImage] = useState<string | undefined>(effectiveImages?.[0])

  // Reset main image whenever selectedVariant changes or images update
  useEffect(() => {
    setMainImage(effectiveImages?.[0])
  }, [selectedVariant, images])

  const hasImages = effectiveImages?.length > 0

  if (!hasImages) {
    return (
      <div className="w-full aspect-square rounded-lg border border-gray-200 bg-gray-50" />
    )
  }

  return (
    <div className="flex justify-end">
      {/* Left thumbs */}
      {effectiveImages?.length > 1 && (
        <div className="flex flex-nowrap overflow-auto sm:mt-1 sm:order-1 sm:w-1/5 sm:max-h-[460px] sm:flex-wrap sm:overflow-auto scrollbar-none">
          {effectiveImages?.map((src) => {
            const active = mainImage === src
            return (
              <button
                key={src}
                type="button"
                onClick={() => { setMainImage(src) }}
                className={[
                  'shrink-0 overflow-hidden rounded-xl border bg-white sm:mb-1 sm:w-[100px]',
                  active ? 'border-[#E20074] ring-2 ring-[#E20074]/40' : 'border-gray-300 hover:border-gray-400'
                ].join(' ')}
              >
                <div className="relative w-full pt-[100%]">
                  <Image
                    src={src}
                    alt={imageAlt ?? 'Product thumbnail'}
                    fill
                    sizes="100px"
                    className="object-contain"
                    loading="lazy"
                  />
                </div>
              </button>
            )
          })}
        </div>
      )}
      {/* Main image */}
      <div className="order-1 w-[480px] h-[480px] rounded-xl border-2 border-[#9E9E9E] p-1">
        {mainImage !== undefined && (
          <Image
            src={mainImage}
            alt={imageAlt ?? 'Product image'}
            width={470}
            height={470}
            priority
            fetchPriority="high"
            sizes="470px"
            className="w-[470px] h-[470px] object-contain"
          />
        )}
      </div>
    </div>
  )
}

export default ProductImageCarousal
